export const SSO_RETURN_URL_KEY = 'eleo.sso.return_url'
